module.exports = {
    encode: require('./encode.js')
  , decode: require('./decode.js')
  , encodingLength: require('./length.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/multiplex/~/varint/index.js
// module id = 344
// module chunks = 0